module.exports = __webpack_public_path__ + "media/error.8dc08f2a.mp3";